module.exports = __webpack_public_path__ + "assets/img/36_1513_big.ce8da964.jpg";